(function () {
  function createShippingResultNotice(marker) {
    const notice = document.createElement('aside');
    const title = marker.dataset.productTitle || 'Este produto';
    const shippingDate = marker.dataset.shippingDate || '29/08';

    notice.className = 'caleo-preorder-notice caleo-preorder-notice--shipping-result';
    notice.dataset.caleoPreorderShippingResult = 'true';
    notice.setAttribute('role', 'note');

    const content = document.createElement('span');
    content.className = 'caleo-preorder-notice__content';

    const heading = document.createElement('strong');
    heading.textContent = 'Prazo especial de pré-venda';

    const message = document.createElement('span');
    message.textContent = `${title} será enviado a partir de ${shippingDate}. O prazo exibido acima considera somente o transporte e começa a contar após o envio.`;

    content.appendChild(heading);
    content.appendChild(message);
    notice.appendChild(content);

    return notice;
  }

  function initProductShippingNotice() {
    const marker = document.querySelector('[data-caleo-preorder-product]');
    if (!marker) return;

    let updateScheduled = false;

    const updateNotice = () => {
      updateScheduled = false;

      const carrierResults = document.getElementById('calc-carrier');
      if (!carrierResults) return;

      const hasCalculatedRate = carrierResults.querySelector('.ship-price');
      const existingNotice = carrierResults.querySelector('[data-caleo-preorder-shipping-result]');

      if (!hasCalculatedRate) {
        if (existingNotice) existingNotice.remove();
        return;
      }

      if (!existingNotice) {
        carrierResults.appendChild(createShippingResultNotice(marker));
      }
    };

    const scheduleUpdate = () => {
      if (updateScheduled) return;
      updateScheduled = true;
      window.requestAnimationFrame(updateNotice);
    };

    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(document.body, { childList: true, subtree: true });
    scheduleUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductShippingNotice);
  } else {
    initProductShippingNotice();
  }
})();
